import { useState, useEffect } from "react";
import {
    Card,
    CardHeader,
    Table,
    Container,
    Row,
    CardFooter,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import Loader from "components/Loader.js";
import axios from "axios";

const API_URL = process.env.REACT_APP_AUTH_URL.replace('/auth', '');

const GoogleAdsReport = () => {
    const [accounts, setAccounts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCampaigns = async () => {
            try {
                const token = localStorage.getItem("token");
                const config = {
                    headers: { Authorization: `Bearer ${token}` }
                };

                // console.log('🔍 Fazendo requisição para:', `${API_URL}/ads/report`);
                const response = await axios.get(`${API_URL}/ads/report`, config);
                // console.log('✅ Resposta recebida:', response.data);
                // console.log('📊 Número de contas:', response.data.length);
                setAccounts(response.data);
            } catch (error) {
                console.error("❌ Erro ao buscar dados do Google Ads:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCampaigns();
    }, []);

    if (loading) {
        return (
            <>
                <Header />
                <Loader />
            </>
        );
    }

    return (
        <>
            <Header />
            <Container className="mt--7" fluid>
                <Row>
                    <div className="col">
                        <Card className="shadow">
                            <CardHeader className="border-0">
                                <h3 className="mb-0">Relatório Google Ads (Agência)</h3>
                            </CardHeader>

                            {accounts.length > 0 ? (
                                accounts.map((account) => (
                                    <div key={account.accountId} className="mb-4">
                                        <div className="px-4 py-2 bg-secondary">
                                            <h4 className="mb-0 text-primary">{account.accountName} (ID: {account.accountId})</h4>
                                        </div>
                                        <Table className="align-items-center table-flush" responsive>
                                            <thead className="thead-light">
                                                <tr>
                                                    <th scope="col">Campanha</th>
                                                    <th scope="col">Cliques</th>
                                                    <th scope="col">Impressões</th>
                                                    <th scope="col">Custo</th>
                                                    <th scope="col">Conversões</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {account.campaigns.length > 0 ? (
                                                    account.campaigns.map((campaign, index) => (
                                                        <tr key={index}>
                                                            <th scope="row">{campaign.campaignName}</th>
                                                            <td>{campaign.clicks}</td>
                                                            <td>{campaign.impressions}</td>
                                                            <td>
                                                                {new Intl.NumberFormat("pt-BR", {
                                                                    style: "currency",
                                                                    currency: "BRL",
                                                                }).format(campaign.cost)}
                                                            </td>
                                                            <td>{campaign.conversions}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">
                                                            Nenhuma campanha encontrada nesta conta.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                ))
                            ) : (
                                <div className="p-4 text-center">
                                    Nenhuma conta encontrada.
                                </div>
                            )}

                            <CardFooter className="py-4">
                                {/* Paginação pode ser implementada por conta se necessário */}
                            </CardFooter>
                        </Card>
                    </div>
                </Row>
            </Container>
        </>
    );
};

export default GoogleAdsReport;
